import React from 'react';

export default function Popsicle() {
	return (
		<g>
			<path fill="#FD9797" d="M125.2073669,385.0257568c0.0602798,1.5744629,0.3826218,5.8757935-13.2877655,7.8314514
				c-22.9886169,3.2887573-44.6419983-1.0307312-44.8177948-5.6208496
				c-0.2936249-7.6669922,17.5902405-7.3414001,41.2650757-9.9037476
				C121.9426727,375.8633118,125.0872345,381.888092,125.2073669,385.0257568z" />
			<path fill="#FCDAC9" d="M37.1227455,307.5670166l0.0000076-0.0000305c2.9785652-2.9785461,7.807766-2.9785461,10.7863312,0
				l17.7245293,17.7245483L54.847271,336.0778809l-17.7245255-17.7245483
				C34.1441803,315.3747864,34.1441803,310.5455627,37.1227455,307.5670166z" />
			<path fill="#FD9797" d="M72.2578354,313.7215271c2.2909851-3.2400818,6.9475937-3.6366882,9.75354-0.8307495l33.372261,33.3722839
				c13.2153015,13.215271,10.9589157,26.9373474,1.3860626,37.686676c-0.9527588,1.0698547-2.2241058,1.8113403-3.6251526,2.1102905
				l-0.9466934,0.2020264c-10.9300156,2.3322754-22.222496,2.3955688-33.1779785,0.1860046l-1.1999588-0.2420044
				c-1.2911911-0.2604065-2.4767914-0.8961792-3.4081879-1.8275757l-32.183876-32.1838684
				c-2.6767006-2.6766968-2.2891273-7.1209412,0.8104973-9.2939148l1.7704926-1.2411804
				c3.1578636-2.2137756,5.8709526-5.0020447,7.9976463-8.2192078l0.5543976-0.8386536
				c2.3148994-3.5018921,5.3225288-6.4925232,8.8374748-8.7875366l0.5214386-0.3404541
				c3.2432747-2.1176453,6.0571022-4.8291626,8.293354-7.9918213L72.2578354,313.7215271z" />
			<path fill="#FC8B8B" d="M76.059288,372.7965698c2.1382904,2.1383057,5.6050873,2.1383057,7.7433777,0
				c2.1382828-2.1382751,2.1382828-5.605072,0-7.7433472c-1.686264-1.6862793-22.5051537-22.5106201-31.2417221-31.2471924
				c-2.0885315,3.0625-4.7154045,5.7246094-7.7524948,7.8540344l-0.0366631,0.0257263
				C53.4756737,350.3377686,74.3700714,371.1073608,76.059288,372.7965698z" />
			<path fill="#FC8B8B" d="M94.7293625,354.1264954c2.1382904,2.1383057,5.6050873,2.1383057,7.7433701,0
				c2.1382904-2.1382751,2.1382904-5.605072,0-7.7433472c-1.69207-1.6920776-22.5797424-22.5797424-31.2282944-31.228302
				l-0.231369,0.3269958c-2.0731583,2.9321289-4.6397171,5.4740906-7.5875435,7.5169678
				C72.2231216,331.7435608,93.0460587,352.4432068,94.7293625,354.1264954z" />
			<path fill="#FD9797" d="M54.7944717,383.5910034c3.4476967,0,5.2781525,2.7640991,5.2781525,4.3650513
				c0,1.6009216-1.8304558,2.5126953-5.2781525,2.5126953c-3.4477005,0-5.2781563-0.9117737-5.2781563-2.5126953
				C49.5163155,386.3551025,51.3467712,383.5910034,54.7944717,383.5910034z" />
		</g>
	);
}



// WEBPACK FOOTER //
// ./src/components/Global/Goodies/Toy/Popsicle.js